import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select } from 'antd';

import {
  branchAccessEndpoints,
  companyAccessEndpoints,
  customerApiEndpoints,
} from '@/api/endpoints';
import { optionSearchFunction } from '@/utils/common';

import { handleUpdatePostApi } from '@/api/crud';
import { useGetApiList } from '@/apiError/apiShow';
import { useFetch } from '@/hooks';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import { rules } from '@/utils/validation/FormValidation';

const EditCustomer = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const controller = new AbortController();

  const { data } = useFetch(branchAccessEndpoints.retrieveList);

  const { data: { data: storeList } = {}, isPending: storeLoading } =
    useGetApiList('/admin/stores/');

  useEffect(() => {
    const signal = controller.signal;
    async function handleCompanyDetailsOnLoad() {
      try {
        const res = await customerApiEndpoints.retrieve(id, signal);

        if (res.data.data) {
          const customer = res.data.data;
          if (customer) {
            form.setFieldsValue({
              ...customer,
              branchIds: customer.branchReferenceIds || [],
              storeId: customer.storeReferenceIds || [],
            });
          }
        }
      } catch (error) {
        throw new Error(error);
      }
    }

    handleCompanyDetailsOnLoad();

    //  clear up function
    return () => {
      controller.abort();
    };
  }, [id]);

  const navigateToList = () => navigate('/user/list/');

  return (
    <>
      <Card>
        <Form
          className="username"
          form={form}
          onFinish={(value) => {
            handleUpdatePostApi(
              id,
              customerApiEndpoints.update,
              {
                ...value,
              },
              setLoading,
              form,
              navigateToList,
            );
          }}
          layout="vertical"
        >
          <LoadingOverlay spinning={loading} />
          <GlobalDivider name="Edit User" />
          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Username"
                name="username"
                rules={rules.required}
                hasFeedback
                validateTrigger="onChange"
              >
                <Input placeholder="Username" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="First Name" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Last Name" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Email" name="email">
                <Input placeholder="example@domin.com" autoComplete="off" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Address" name="address">
                <Input placeholder="Address" autoComplete="off" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Select Branch"
                name="branchIds"
                validateTrigger="onChange"
              >
                <Select
                  placeholder="Select Branch"
                  filterOption={(value, option) => {
                    optionSearchFunction(value, option);
                  }}
                  options={data?.map((item) => {
                    return {
                      value: item.referenceId,
                      label: item?.name,
                    };
                  })}
                  mode="multiple"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Store"
                name="storeId"
                validateTrigger="onChange"
                required
              >
                <Select
                  showSearch
                  allowClear
                  mode="multiple"
                  loading={storeLoading}
                  placeholder="Select Store"
                  filterOption={optionSearchFunction}
                  options={storeList?.map((item) => {
                    return {
                      value: item.referenceId,
                      label: item?.name,
                    };
                  })}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Mobile"
                name="mobileNumber"
                rules={rules.phoneNumber}
                validateTrigger="onChange"
              >
                <Input type="tel" placeholder="98XXXXXXX" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end">
            <div className="flex gap-2">
              <Button type="primary" htmlType="submit">
                Update
              </Button>
              <Button className="auto-danger-btn" onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default EditCustomer;
